import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import DeenLockLanding from "./DeenLockLanding";
import PrivacyPolicy from "./PrivacyPolicy";
import TermsOfUse from "./TermsOfUse";

export default function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<DeenLockLanding />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-use" element={<TermsOfUse />} />
      </Routes>
    </Router>
  );
}
